export default "__VITE_ASSET__C$_EwE2Q__"